import React, { useState, useMemo, useCallback } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import Navbar from "../components/Navbar";
import "../styles/ServicePage.css";

// Import images from the assets folder
import developmentImg from "../assets/development.webp";
import chatbotImg from "../assets/chatbot.webp";
import vaptImg from "../assets/vapt.webp";
import mobileAppImg from "../assets/mobilepentesting.webp";
import cloudConsultingImg from "../assets/cloudconsulting.webp";
import cloudImplementationImg from "../assets/cloudimplementation.webp";
import aiMlConsultingImg from "../assets/ai-ml.webp";
import techAdvisoryImg from "../assets/advisory.webp";
import techStackImg from "../assets/techstack.webp";
import securityAwarenessImg from "../assets/securityawareness.webp";
import dataAnalysisImg from "../assets/dataanalysis.webp";
import blockchainDevImg from "../assets/blockchain.webp";

const services = [
  {
    title: "Custom Application Development",
    description:
      "Possess tailor-made applications that allow for expedient and reliable execution of work and improved digital presence.",
    link: "/CAD",
    category: "Development",
    image: developmentImg,
  },
  {
    title: "Conversational AI Chatbot Development",
    description:
      "Future-proof customer interaction with cutting-edge conversational AI chatbots.",
    link: "/ConversationalAIChatbotDevelopment",
    category: "Development",
    image: chatbotImg,
  },
  {
    title: "Vulnerability Assessment Penetration Testing (VAPT)",
    description:
      "VAPT services are aimed at advancing the defence of digital assets..",
    link: "/VAPT",
    category: "Security Testing",
    image: vaptImg,
  },
  {
    title: "Mobile App Pentesting",
    description:
      "Our mobile application penetration testing entails extensive testing coupled with professional analysis.",
    link: "/MobileAppPentesting",
    category: "Security Testing",
    image: mobileAppImg,
  },
  {
    title: "Cloud Consulting",
    description:
      "Enhance your cloud views with expertise that guarantees performance optimization at low costs.",
    link: "/CloudConsulting",
    category: "Cloud",
    image: cloudConsultingImg,
  },
  {
    title: "Cloud Implementation Service",
    description:
      "Experience a seamless cloud transition with our tailored implementation services.",
    link: "/CloudImplementationService",
    category: "Cloud",
    image: cloudImplementationImg,
  },
  {
    title: "Artificial Inteliigence and Machine Learning Consulting",
    description:
      "Realize the transformative capabilities of AI and ML through expert consulting..",
    link: "/AIAndMLConsulting",
    category: "Consulting",
    image: aiMlConsultingImg,
  },
  {
    title: "Tech Advisory & Consulting",
    description:
      "Propel forward with innovation through tech advisories from our panel of experts.",
    link: "/TechAdvisoryConsulting",
    category: "Consulting",
    image: techAdvisoryImg,
  },
  {
    title: "Tech Stack as a Service (TStaaS)",
    description:
      "The Tech Stack as a Service encapsulates the end-to-end development solutions by integrating security, AI/ML, cloud, blockchain, pentesting, etc., to realize secure and scalable digital innovations.",
    link: "/TechStackAsAService",
    category: "Other Services",
    image: techStackImg,
  },
  {
    title: "Corporate or Security Awareness Training",
    description:
      "Elevate your team’s capabilities with dynamic tech training and corporate workshops.",
    link: "/CorporateSecurityAwarenessTraining",
    category: "Other Services",
    image: securityAwarenessImg,
  },
  {
    title: "Data Analysis",
    description:
      "Our analysts make sense of your data and drill valuable insights out of it.",
    link: "/DataAnalysis",
    category: "Other Services",
    image: dataAnalysisImg,
  },
  {
    title: "Blockchain Development Services",
    description:
      "Decentralized apps, smart contracts, and blockchain solutions development that allows for secure and transparent business operations.",
    link: "/BlockchainDevelopmentServices",
    category: "Web3",
    image: blockchainDevImg,
  },
];

const filterOptions = [
  { value: "All", label: "All Services" },
  { value: "Development", label: "Development" },
  { value: "Security Testing", label: "Security Testing" },
  { value: "Cloud", label: "Cloud" },
  { value: "Consulting", label: "Consulting" },
  { value: "Other Services", label: "Other Services" },
  { value: "Web3", label: "Web3" },
];

const ServiceCard = React.memo(({ title, description, link, image, initialX }) => (
  <motion.div
    className="service-card"
    initial={{ opacity: 0, x: initialX }}
    whileInView={{ opacity: 1, x: 0 }}
    viewport={{ once: true, amount: 0.3 }}
    transition={{ duration: 0.1, ease: "easeOut" }}
    whileHover={{ scale: 1.02 }}
  >
    <div className="service-content">
      <h2>{title}</h2>
      <p>{description}</p>
      <Link to={link} className="view-service">
        View Service
      </Link>
    </div>
    <div className="service-image">
      <img src={image} alt={title} className="service-img" />
    </div>
  </motion.div>
));

const Services = () => {
  const [selectedCategory, setSelectedCategory] = useState("All");

  const filteredServices = useMemo(() => {
    return selectedCategory === "All"
      ? services
      : services.filter((service) => service.category === selectedCategory);
  }, [selectedCategory]);

  const handleFilterChange = useCallback((event) => {
    setSelectedCategory(event.target.value);
  }, []);

  return (
    <div className="service-page">
      <div className="el"></div>
      <Navbar />
      <div className="service-header">
        <h1>Our Offerings</h1>
        <h2>Discover our comprehensive range of offerings</h2>
      </div>
      <div className="filter-container">
        <select value={selectedCategory} onChange={handleFilterChange}>
          {filterOptions.map(({ value, label }) => (
            <option key={value} value={value}>
              {label}
            </option>
          ))}
        </select>
      </div>
      <div className="service-grid">
        {filteredServices.map((service, index) => (
          <ServiceCard
            key={service.title} // Assuming titles are unique
            initialX={index % 2 === 0 ? -50 : 50}
            {...service}
          />
        ))}
      </div>
    </div>
  );
};

export default Services;
